import { Component, Injector, ViewEncapsulation, OnInit, Input } from '@angular/core';
import { AppComponentBase } from '../../../../../../shared/common/app-component-base';

import * as _ from 'lodash';

import { AppConsts } from "../../../../../../shared/AppConsts";

@Component({
    selector: 'app-image-container',
    templateUrl: './image-container.component.html',
    styleUrls: ['./image-container.component.less'],
    encapsulation: ViewEncapsulation.None,
})
export class ImageContainerComponent extends AppComponentBase implements OnInit {
   
    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;

    //#region Props

    @Input() articleId: string;
    @Input() height: number = 38;
    
    //#endregion
    

    constructor(
        injector: Injector,
    ) {
        super(injector);
    }

    ngOnInit(): void {

    }

    getImgUrl() {
        return `${this.remoteServiceBaseUrl}/WebShop/${this.appSession.tenant.id}/GetArticleImage/${this.articleId}.jpg`;
    }


}
